import React from 'react';

import {
    useSsSelector as useSelector,
} from '~SpectateStore';

import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import {
    selectIsPlacingBet,
    selectDisplayFullslip,
} from '~Betslip/selectors/uiSelectors';

const PlacingBet = () => {
    const [t] = useTranslation();
    const isPlacingBet = useSelector(selectIsPlacingBet);
    const displayFullslip = useSelector(selectDisplayFullslip);
    const displayPlacingBet = isPlacingBet && !displayFullslip;

    const transition = {
        type: 'spring',
        damping: 80,
        stiffness: 900,
    };

    const variants = {
        hidden: { y: '100%' },
        visible: { y: '0%' },
        exit: { y: '100%' },
    };

    return (
        <AnimatePresence>
            {displayPlacingBet &&
                <motion.div
                    transition={transition}
                    variants={variants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    className='babyslip__placing-bet'
                >
                    {t('betslip.placing_bet')}
                </motion.div>
            }
        </AnimatePresence>
    );
};

export default PlacingBet;
